import AutorenewIcon from '@mui/icons-material/Autorenew';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Typography } from '@mui/material';
import { styled, useTheme } from '@mui/system';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { TASK_STATUS } from '../../../constants/serverConstants';
import { sentenceCase } from '../../../utils/utils';

const getStatusColor = (theme, status) => {
  switch (status) {
    case TASK_STATUS.COMPLETED:
      return theme.palette.success.main;
    case TASK_STATUS.FAILED:
      return theme.palette.error.main;
    case TASK_STATUS.RUNNING:
      return theme.palette.info.main;
    default:
      return theme.palette.text.primary;
  }
};

const StatusIconWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const SpinIcon = styled(AutorenewIcon)({
  animation: 'spin 3s linear infinite',
  '@keyframes spin': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' },
  },
});

const StatusText = styled(Typography)(({ theme, status }) => ({
  marginLeft: '0.5em',
  fontWeight:
    status === TASK_STATUS.PENDING
      ? theme.typography.fontWeightRegular
      : theme.typography.fontWeightBold,
  color: getStatusColor(theme, status),
}));

const JobStatus = ({ status }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const color = getStatusColor(theme, status);

  return (
    <StatusIconWrapper>
      {status === TASK_STATUS.COMPLETED && (
        <CheckCircleOutlineIcon fontSize="small" style={{ color }} />
      )}
      {status === TASK_STATUS.FAILED && (
        <ErrorOutlineIcon fontSize="small" style={{ color }} />
      )}
      {status === TASK_STATUS.RUNNING && (
        <SpinIcon fontSize="small" style={{ color }} />
      )}
      <StatusText status={status}>
        {sentenceCase(t(status.toLowerCase(), { ns: 'gps' }))}
      </StatusText>
    </StatusIconWrapper>
  );
};

// PropTypes validation
JobStatus.propTypes = {
  status: PropTypes.oneOf([
    TASK_STATUS.COMPLETED,
    TASK_STATUS.FAILED,
    TASK_STATUS.RUNNING,
    TASK_STATUS.PENDING,
  ]).isRequired,
};

export default JobStatus;
